<template>
  <v-card class="pa-2" :flat="root">
    <task-json-editor
      v-for="(child, i) in localData"
      :key="`child-${i}`"
      v-model="localData[i]"
      :schema="addIdx(fields, i)"></task-json-editor>

    <v-main class="mt-2">
      <v-layout>
        <v-flex class="text-xs-right">
          <v-btn color="primary" @click="addChild">
            <v-icon>add</v-icon>  &nbsp; {{ fields.title }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-main>
  </v-card>
</template>

<script>
import Field from '@/mixins/JsonEditorField'

export default {
  name: 'NestedField',
  components: {
    /**
     * We must import the component dynamically to avoid circular reference
     *
     * @returns {Promise<*>|*}
     * @constructor
     */
    TaskJsonEditor: () => import('@/components/JsonEditor/TaskJsonEditor')
  },
  mixins: [Field],
  data () {
    return {
      localData: []
    }
  },
  methods: {
    /**
     * Adds a new child component
     */
    addChild () {
      this.localData.push({})
    },
    /**
     * Returns a child's schema, appending its index in the title
     *
     * @param schema
     * @param idx
     * @returns {{title: string}}
     */
    addIdx (schema, idx) {
      return { ...schema, title: schema.title + ` (${idx + 1})` }
    }
  }
}
</script>
